(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[640],{

/***/ 66929:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-it-works",
      function () {
        return __webpack_require__(9487);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 20768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_LandingPageTile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/LandingPageTile.module.scss
var LandingPageTile_module = __webpack_require__(37422);
var LandingPageTile_module_default = /*#__PURE__*/__webpack_require__.n(LandingPageTile_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/images/default-tile-cover.png
/* harmony default export */ var default_tile_cover = ({"src":"/_next/static/media/default-tile-cover.80dc6840.png","height":266,"width":400,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAXVBMVEWsWGS/z8bNzM+UeY6VYVrQooaTkJHItpm4bnO2ZFmNa3LAg42mY3mwaG3MnpTBc3+8XG/RdXrSim+/rKzTm2CdhIeMgX+qtbCuwLvYqJOwppTQva3erlyZpY7PxJnpbCRhAAAACXBIWXMAAAsSAAALEgHS3X78AAAANUlEQVR4nGOQYGRkkpZjZ2dgk5WSlBFh5WNgExNnFRLk52ZgFmUS5hBg4GHgYmHh5OTlYAAAMmgB/B686NgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./components/LandingPageTile.js





const LandingPageTile = /*#__PURE__*/ (0,react.forwardRef)((param, ref)=>{
    let { onClick , href , page  } = param;
    const imageUrl = page.thumbnail.url || default_tile_cover.src;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((LandingPageTile_module_default()).imageContainer, " mb-2"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: href,
                    onClick: onClick,
                    ref: ref,
                    className: (LandingPageTile_module_default()).imageLink,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: imageUrl,
                        className: (LandingPageTile_module_default()).image,
                        alt: page.header1,
                        fill: true,
                        sizes: "100vw"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: href,
                onClick: onClick,
                ref: ref,
                className: "d-block text-dark text-center text-decoration-none",
                children: page.linkTitle
            })
        ]
    });
});
LandingPageTile.displayName = "LandingPageTile";
/* harmony default export */ var components_LandingPageTile = (LandingPageTile);


/***/ }),

/***/ 15666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PopularSubjectsHero; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _footer_data_preval__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43397);
/* harmony import */ var _footer_data_preval__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_footer_data_preval__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10682);
/* harmony import */ var _LandingPageTile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20768);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31555);







function PopularSubjectsHero() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "py-5",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "mb-4 text-center",
                    children: "Popular Subjects"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    children: _footer_data_preval__WEBPACK_IMPORTED_MODULE_2___default().subjects.map((subject)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            md: 3,
                            xs: 12,
                            className: "mb-3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: "/tutoring/".concat(subject.slug),
                                passHref: true,
                                legacyBehavior: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LandingPageTile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    page: subject
                                })
                            })
                        }, subject.id))
                })
            ]
        })
    });
}


/***/ }),

/***/ 9487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ HowItWorks; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/NumericIcon.module.scss
var NumericIcon_module = __webpack_require__(73157);
var NumericIcon_module_default = /*#__PURE__*/__webpack_require__.n(NumericIcon_module);
;// CONCATENATED MODULE: ./components/NumericIcon.js


function NumericIcon(param) {
    let { number  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "".concat((NumericIcon_module_default()).number, " text-muted"),
        children: [
            number,
            "."
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/images/how-it-works-1.png
/* harmony default export */ var how_it_works_1 = ({"src":"/_next/static/media/how-it-works-1.49eda025.png","height":590,"width":976,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAD1BMVEX9/f3m6Orl6OmGkZuAi5UjVGhqAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAE0lEQVR4nGNgwA0YmaAMFmYIAwAAkwALrdDpJwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/images/how-it-works-2.png
/* harmony default export */ var how_it_works_2 = ({"src":"/_next/static/media/how-it-works-2.73bd49c6.png","height":614,"width":932,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAKlBMVEX8+/ni7/hAn9/H4fL19PPx7uzn8PfX6PLh4+O/xcmYzO57vOhQp+HA3e4PdE5ZAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAK0lEQVR4nBXJyREAMAgCQCCiOftvN+N+F2HbAaDeaMTRlaSNZJKsRPRjrg8PAgCiZEcDQwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/images/how-it-works-3.png
/* harmony default export */ var how_it_works_3 = ({"src":"/_next/static/media/how-it-works-3.bf968d60.png","height":732,"width":978,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAD1BMVEX+/v73+Pn09PTd7+3a2t1EhczmAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAJUlEQVR4nE2IsQ0AMAyDwM7/N1eRMpQFBG1nVIQIkJA1ehF3fjwGXAAqn51SJgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/how-it-works-4.png
/* harmony default export */ var how_it_works_4 = ({"src":"/_next/static/media/how-it-works-4.a5e4e2a9.png","height":472,"width":970,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAElBMVEX8/f319vfW2dvc3+HDyM3m5+hg7WcAAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAH0lEQVR4nGNgYmJmYmJkZGSAA0ZGVkYGRmYmKJeJBQACqQAjpVtmNgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":4});
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./components/PopularSubjectsHero.js
var PopularSubjectsHero = __webpack_require__(15666);
// EXTERNAL MODULE: ./components/HowItWorksHero.module.scss
var HowItWorksHero_module = __webpack_require__(57874);
var HowItWorksHero_module_default = /*#__PURE__*/__webpack_require__.n(HowItWorksHero_module);
;// CONCATENATED MODULE: ./public/images/how-it-works-bg.jpg
/* harmony default export */ var how_it_works_bg = ({"src":"/_next/static/media/how-it-works-bg.89afe940.jpg","height":1280,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAcEAABBAMBAAAAAAAAAAAAAAAAAQMREgIEIUH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAv/EABYRAQEBAAAAAAAAAAAAAAAAAAEAEf/aAAwDAQACEQMRAD8Aq4abL7CWRa0is+rPQARhBb//2Q==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./components/HowItWorksHero.js





function HowItWorksHero() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((HowItWorksHero_module_default()).heroContainer, " "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (HowItWorksHero_module_default()).overlay
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: how_it_works_bg,
                className: (HowItWorksHero_module_default()).backgroundImage,
                alt: "Cover photo",
                priority: true,
                fill: true,
                sizes: "100vw",
                style: {
                    objectFit: "cover",
                    objectPosition: "center"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: "".concat((HowItWorksHero_module_default()).content, " d-flex h-100"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-white text-center my-auto w-100",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "my-5",
                        children: "Find the Perfect Tutor in Minutes"
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/how-it-works.js














function HowItWorks() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "How Tutorspot Works | Online and In-person tutoring | Tutorspot"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksHero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            xs: 12,
                            md: 9,
                            className: "mx-md-auto",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                    className: "mb-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-xs-12 col-md-7",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NumericIcon, {
                                                    number: 1
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                    children: [
                                                        "Use our simple",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "tutors/search",
                                                            children: "search"
                                                        }),
                                                        " ",
                                                        "tools to find your perfect tutor"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-xs-12 col-md-5 pt-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: how_it_works_1,
                                                className: "shadow-lg w-100",
                                                style: {
                                                    maxWidth: "100%",
                                                    height: "auto",
                                                    width: "auto"
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                    className: "mb-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-xs-12 col-md-7 order-md-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NumericIcon, {
                                                    number: 2
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: "Message tutors directly from Tutorspot to discuss details and confirm scheduling"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-xs-12 col-md-5 pt-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: how_it_works_2,
                                                className: "shadow-lg w-100",
                                                style: {
                                                    maxWidth: "100%",
                                                    height: "auto",
                                                    width: "auto"
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                    className: "mb-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-xs-12 col-md-7",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NumericIcon, {
                                                    number: 3
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: "Begin lessons with your chosen tutor either in-person or online"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-xs-12 col-md-5 pt-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: how_it_works_3,
                                                className: "shadow-lg w-100",
                                                style: {
                                                    maxWidth: "100%",
                                                    height: "auto",
                                                    width: "auto"
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                    className: "mb-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-xs-12 col-md-7 order-md-1",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NumericIcon, {
                                                    number: 4
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    children: "Payment is taken automatically after each lesson. Simple!"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-xs-12 col-md-5 pt-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: how_it_works_4,
                                                className: "shadow-lg w-100",
                                                style: {
                                                    maxWidth: "100%",
                                                    height: "auto",
                                                    width: "auto"
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularSubjectsHero/* default */.Z, {})
        ]
    });
}


/***/ }),

/***/ 57874:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heroContainer":"HowItWorksHero_heroContainer__keQ36","overlay":"HowItWorksHero_overlay__6mavj","backgroundImage":"HowItWorksHero_backgroundImage__LTNOO","content":"HowItWorksHero_content__Hj0Pz"};

/***/ }),

/***/ 37422:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"LandingPageTile_imageContainer__vIAv6","imageLink":"LandingPageTile_imageLink__qYp7c","image":"LandingPageTile_image__9cmfi"};

/***/ }),

/***/ 73157:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"number":"NumericIcon_number__BAaB2"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(66929); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);